import http from '../../api/http';
/**
 * 聚合付校验配置参数获取
 */
export const getCampusPay = (params) => http("get", '/project/campusPay/verify/param', params)
/**
 * 获取校园聚合付账户基本信息
 */
export const getAccInfo=(params)=>  http("get", '/settlement/campus/getAccountInfo', params)
/**
 * 开通一卡通免密
 */
export const openCardFree=(params)=>http('post','/settlement/campus/agreement/open?&projectId='+params.projectId+'&campusPassword='+params.campusPassword+'&campusAccount='+params.campusAccount
+'&telPhone='+params.telPhone+'&userId='+params.userId+'&accountId='+params.accountId+'&loginCode='+params.loginCode+'&phoneSystem='+params.phoneSystem+'&campusName='+params.campusName
)